// * GET =====================================
export const RULE_GET = (ruleId: string) => `/rule/${ruleId}`;

export const RULE_GET_HISTORY = (ruleId: string) => `/rule/${ruleId}/history`;

export const RULE_GET_VOLUME = (ruleId: string) => `/rule/${ruleId}/volume`;

export const RULE_GET_EXECUTIONS = (ruleId: string) =>
  `/rule/${ruleId}/executions`;

export const RULE_GET_API_CALL_DETAIL = (ruleId: string) =>
  `/rule/${ruleId}/api_call_detail`;

export const RULE_GET_ESTIMATION = (ruleId: string) =>
  `/rule/${ruleId}/estimation`;

export const RULE_GET_STATISTICS = (ruleId: string) =>
  `/rule/${ruleId}/statistics`;

// * PATCH ===================================
export const RULE_PATCH = (ruleId: string) => `/rule/${ruleId}`;

// * POST ====================================
export const RULE_POST_ACTIVATE = (ruleId: string) =>
  `/rule/${ruleId}/activate`;

export const RULE_POST_DEACTIVATE = (ruleId: string) =>
  `/rule/${ruleId}/deactivate`;

export const RULE_POST_ARCHIVE = (ruleId: string) => `/rule/${ruleId}/archive`;

export const RULE_POST_REVIEW = (ruleId: string) => `/rule/${ruleId}/review`;

export const RULE_POST_REJECT = (ruleId: string) => `/rule/${ruleId}/reject`;

export const RULE_POST_ESTIMATE = `/rule/estimate`;

export const RULE_POST_API_CALLS = (ruleId: string) =>
  `/rule/${ruleId}/api_calls`;

export const RULE_POST_ANALYZE = (ruleId: string) => `/rule/${ruleId}/analyze`;

// * DELETE ==================================

// * PUT =====================================
export const RULE_PUT = `/rule`;
